import React ,{ PropTypes } from 'react';
import {Link} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';

class SmallCard extends React.PureComponent{

  static propTypes = {
    cat: PropTypes.string,
    description: PropTypes.string,
    lang: PropTypes.string,
    name: PropTypes.string,
    photo: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array
    ]),
    pk: PropTypes.number,
    price: PropTypes.number,
    restaurant: PropTypes.string,
    slug: PropTypes.string,
    wineType: PropTypes.string
  };


  checkDescription() {
    let desc = this.props.description;
    let response = this.props.wineType;
    //if there is an item description, 
    if(desc) {
      // clean html tags
      desc = desc.replace(/<[^>]+>/g, '');
      //truncate it to 7 words
      desc = desc.split(" ").splice(0,7).join(" ");
      response = desc;
    }

    return response ? (<p className="description">{response}</p>) : null;
  }

  render() {
    return (
      <Link to={'/' + this.props.lang + '/' + this.props.restaurant +  `/items/` + this.props.cat + '/' + this.props.slug +
      '-' + this.props.pk + '/'}
            className="small-card">
        <div className="small-thumb"><img src={this.props.photo}/></div>
        <div className="item-content">
          <h4 className="small-item-title">{this.props.name}</h4>
          {this.checkDescription()}
          {
          this.props.price ? 
          <span className="price">{this.props.price}€</span> :
          <FormattedMessage id="price_under_request">
            {(message) => <span className="price">
            {message}
          </span>}
          </FormattedMessage>
          
          }
        </div>
      </Link>
    );

  }
}

export default SmallCard;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/core/SmallCard.js
 **/